<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container justify-content-center">

      <!--<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false">-->
        <!--<span class="navbar-toggler-icon"/>-->
      <!--</button>-->

      <div class="text-center" style="padding:1.3rem 0;">

          <img v-if="site === 'gentech'" src="/images/gentech_logo.png" alt="Gentech" style="max-width:90px;">
          <img v-if="site === 'nativfilter'" src="/images/nativ_logo.png" alt="Nativfilter" style="max-width:200px;">
      </div>

      <!--<div id="navbarToggler" class="collapse navbar-collapse">-->
        <!--<ul class="navbar-nav">-->
          <!--<locale-dropdown/>-->
          <!--<li class="nav-item">-->
            <!--<a class="nav-link" href="#">Link</a>-->
          <!--</li>-->
        <!--</ul>-->
      <!--</div>-->
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import LocaleDropdown from './LocaleDropdown'

export default {
  components: {
    LocaleDropdown
  },

  data: () => ({
    appName: window.config.appName,
    site: window.config.getSite
  }),

  computed: mapGetters({
    user: 'auth/user'
  }),

  methods: {
    async logout () {
      // Log out the user.
      await this.$store.dispatch('auth/logout')

      // Redirect to login.
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style scoped>
.profile-photo {
  width: 2rem;
  height: 2rem;
  margin: -.375rem 0;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/components/Navbar.vue